
const initailState = {
    arr:[],
    nextKey:''
}
const Simdata=(state=initailState,action)=>{
    switch(action.type){
        case 'ADD_SIM_DATA':
            return{ 
                arr: state.arr.concat(action.payload),
                nextKey:action.nextKey
            }
        default:
            return state;
    }
}

export default Simdata